export const COMPANY = {
  name: "Lamonì Lab srl",
  street: "Via dell'Osteria del Finocchio 37",
  cityLine: "00132 Roma (RM)",
  address: "Via dell'Osteria del Finocchio 37, 00132 Roma (RM)",
  vat: "11371351005",
  rea: "RM - 1299080",
  pec: "lamonilab@pecposta.it",
  email: "lamonilabsrl@gmail.com",
  phone: "335 833 0304",
  phoneHref: "tel:+393358330304",
  map: { lat: 41.8575787, lon: 12.6809199 },
};

const { lat, lon } = COMPANY.map;
export const MAP_EMBED_URL = `https://www.openstreetmap.org/export/embed.html?bbox=${lon - 0.006},${lat - 0.003},${lon + 0.006},${lat + 0.003}&layer=mapnik&marker=${lat},${lon}`;
export const MAP_LINK_URL = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=17/${lat}/${lon}`;
export const DIRECTIONS_URL = `https://www.openstreetmap.org/directions?to=${lat},${lon}`;

export const COMPANY_FACTS = [
  { label: "Ragione sociale", value: COMPANY.name },
  { label: "Sede legale", value: COMPANY.address },
  { label: "Codice fiscale e Partita IVA", value: COMPANY.vat },
  { label: "Numero REA", value: COMPANY.rea },
  { label: "PEC", value: COMPANY.pec, href: `mailto:${COMPANY.pec}` },
  { label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}` },
  { label: "Telefono", value: COMPANY.phone, href: COMPANY.phoneHref },
];
